import React, { useState } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { Home, Package, ShoppingCart, Menu, X, AlertTriangle, XCircle, Settings, ClipboardList, Store, HelpCircle, BarChart3 } from 'lucide-react';

const Layout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [aboutPopupOpen, setAboutPopupOpen] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeMobileSidebar = () => {
    setSidebarOpen(false);
  };

  const openAboutPopup = () => {
    setAboutPopupOpen(true);
  };

  const closeAboutPopup = () => {
    setAboutPopupOpen(false);
  };


  const isActive = (path) => {
    return location.pathname === path;
  };


  return (
    <div className="app-container">
      {/* Botón de menú móvil */}
      <button
        className="mobile-menu-btn"
        onClick={toggleMobileSidebar}
        aria-label="Abrir menú"
      >
        <Menu size={24} color="#64748b" />
      </button>

      {/* Sidebar */}
      <div className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''} ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img 
            src="/sf3/ventas/logosinfilas.png" 
            alt="SinFilas Logo" 
            className="sidebar-logo clickable-logo"
            onClick={openAboutPopup}
            style={{ cursor: 'pointer' }}
          />
        </div>

        <nav className="sidebar-nav">
          <Link
            to="/"
            className={`nav-item ${isActive('/') ? 'active' : ''}`}
            onClick={closeMobileSidebar}
          >
            <Home size={20} />
            <span>Dashboard</span>
          </Link>

          <Link
            to="/productos"
            className={`nav-item ${isActive('/productos') ? 'active' : ''}`}
            onClick={closeMobileSidebar}
          >
            <Package size={20} />
            <span>Productos</span>
          </Link>

          <Link
            to="/stock-bajo"
            className={`nav-item ${isActive('/stock-bajo') ? 'active' : ''}`}
            onClick={closeMobileSidebar}
          >
            <AlertTriangle size={20} />
            <span>Stock Bajo</span>
          </Link>

          <Link
            to="/agotados"
            className={`nav-item ${isActive('/agotados') ? 'active' : ''}`}
            onClick={closeMobileSidebar}
          >
            <XCircle size={20} />
            <span>Agotados</span>
          </Link>

          <Link
            to="/ventas"
            className={`nav-item ${isActive('/ventas') ? 'active' : ''}`}
            onClick={closeMobileSidebar}
          >
            <ShoppingCart size={20} />
            <span>Ventas</span>
          </Link>

            <Link
              to="/reportes"
              className={`nav-item ${isActive('/reportes') ? 'active' : ''}`}
              onClick={closeMobileSidebar}
            >
              <BarChart3 size={20} />
              <span>Reportes</span>
            </Link>

          {/* Configuración - Perfil del Comercio */}
          <Link
            to="/perfil-comercio"
            className={`nav-item ${isActive('/perfil-comercio') ? 'active' : ''}`}
            onClick={closeMobileSidebar}
          >
            <Settings size={20} />
            <span>Configuración</span>
          </Link>

          <Link
            to="/ayuda"
            className={`nav-item ${isActive('/ayuda') ? 'active' : ''}`}
            onClick={closeMobileSidebar}
          >
            <HelpCircle size={20} />
            <span>Ayuda</span>
          </Link>
        </nav>

        <div className="sidebar-footer">
          <p>SinFilas v3.0</p>
        </div>
      </div>

      {/* Contenido principal */}
      <main className={`main-content ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <Outlet />
      </main>

      {/* Overlay para móvil */}
      {sidebarOpen && (
        <div
          className="mobile-overlay"
          onClick={closeMobileSidebar}
        />
      )}

      <style jsx>{`
        .app-container {
          display: flex;
          min-height: 100vh;
        }

        .sidebar {
          width: 280px;
          background: linear-gradient(180deg, #1e293b 0%, #334155 100%);
          color: white;
          transition: all 0.3s ease;
          position: fixed;
          left: 0;
          top: 0;
          height: 100vh;
          z-index: 1000;
          overflow-y: auto;
        }

        .sidebar.collapsed {
          width: 80px;
        }

        .sidebar-header {
          padding: 24px 20px;
          text-align: center;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .sidebar-header h1 {
          font-size: 1.8rem;
          font-weight: 700;
          margin: 0 0 8px 0;
          color: #fff;
        }

        .sidebar-header p {
          font-size: 0.9rem;
          color: #94a3b8;
          margin: 0;
        }

        .sidebar-nav {
          padding: 20px 0;
          flex: 1;
        }

        .nav-item {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 16px 20px;
          color: #cbd5e1;
          text-decoration: none;
          transition: all 0.3s ease;
          border-left: 3px solid transparent;
          margin: 4px 16px;
          border-radius: 12px;
          cursor: pointer;
        }

        .nav-item:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #fff;
          border-left-color: #3b82f6;
          transform: translateX(4px);
        }

        .nav-item.active {
          background: rgba(59, 130, 246, 0.2);
          color: #60a5fa;
          border-left-color: #3b82f6;
        }

        .nav-item svg {
          min-width: 20px;
        }

        .nav-item span {
          font-size: 0.95rem;
          font-weight: 500;
          white-space: nowrap;
        }

        .config-menu {
          position: relative;
        }

        .config-button {
          background: none;
          border: none;
          width: 100%;
          text-align: left;
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 16px 20px;
          color: #cbd5e1;
          text-decoration: none;
          transition: all 0.3s ease;
          border-left: 3px solid transparent;
          margin: 4px 16px;
          border-radius: 12px;
          cursor: pointer;
        }

        .config-button:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #fff;
          border-left-color: #3b82f6;
          transform: translateX(4px);
        }

        .config-button.open {
          background: rgba(59, 130, 246, 0.2);
          color: #60a5fa;
          border-left-color: #3b82f6;
        }

        .config-submenu {
          margin-left: 20px;
          margin-top: 8px;
          border-left: 2px solid rgba(255, 255, 255, 0.1);
          padding-left: 16px;
        }

        .submenu-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 16px;
          color: #94a3b8;
          text-decoration: none;
          transition: all 0.3s ease;
          border-radius: 8px;
          margin: 4px 0;
        }

        .submenu-item:hover {
          background: rgba(255, 255, 255, 0.05);
          color: #cbd5e1;
          transform: translateX(4px);
        }

        .submenu-item.active {
          background: rgba(59, 130, 246, 0.1);
          color: #60a5fa;
        }

        .sidebar-footer {
          padding: 20px;
          text-align: center;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          color: #94a3b8;
          font-size: 0.85rem;
        }

        .main-content {
          flex: 1;
          margin-left: 280px;
          transition: margin-left 0.3s ease;
          background: #f8fafc;
        }

        .main-content.collapsed {
          margin-left: 80px;
        }

        .mobile-menu-btn {
          display: none;
        }

        .mobile-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 1500;
        }

        /* Responsive y móvil */
        @media (max-width: 1024px) {
          .sidebar {
            transform: translateX(-100%);
            box-shadow: 2px 0 20px rgba(0, 0, 0, 0.3);
          }

          .sidebar.open {
            transform: translateX(0);
          }

          .main-content {
            margin-left: 0;
          }

          .mobile-menu-btn {
            display: flex !important;
          }

          .sidebar {
            width: 260px;
          }

          .sidebar-header {
            padding: 20px 16px;
          }

          .sidebar-header h1 {
            font-size: 1.6rem;
          }

          .nav-item {
            padding: 14px 16px;
            margin: 2px 12px;
          }

          .nav-item span {
            font-size: 0.9rem;
          }

          .config-button {
            padding: 14px 16px;
            margin: 2px 12px;
          }
        }

        @media (max-width: 768px) {
          .sidebar {
            width: 240px;
          }

          .sidebar-header {
            padding: 16px 12px;
          }

          .sidebar-header h1 {
            font-size: 1.4rem;
          }

          .sidebar-header p {
            font-size: 0.8rem;
          }

          .nav-item {
            padding: 12px 12px;
            margin: 1px 8px;
            gap: 12px;
          }

          .nav-item span {
            font-size: 0.85rem;
          }

          .config-button {
            padding: 12px 12px;
            margin: 1px 8px;
            gap: 12px;
          }

          .config-submenu {
            margin-left: 16px;
            padding-left: 12px;
          }

          .submenu-item {
            padding: 10px 12px;
            gap: 10px;
          }

          .sidebar-footer {
            padding: 16px 12px;
            font-size: 0.8rem;
          }
        }

        @media (max-width: 480px) {
          .sidebar {
            width: 220px;
          }

          .sidebar-header h1 {
            font-size: 1.2rem;
          }

          .nav-item {
            padding: 10px 10px;
            margin: 1px 6px;
            gap: 10px;
          }

          .nav-item span {
            font-size: 0.8rem;
          }

          .config-button {
            padding: 10px 10px;
            margin: 1px 6px;
            gap: 10px;
          }
        }

        /* Animaciones */
        .sidebar {
          animation: slideIn 0.3s ease;
        }

        @keyframes slideIn {
          from {
            transform: translateX(-100%);
          }
          to {
            transform: translateX(0);
          }
        }

        .nav-item {
          position: relative;
          overflow: hidden;
        }

        .nav-item::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
          transition: left 0.5s ease;
        }

        .nav-item:hover::before {
          left: 100%;
        }

        /* Estilos para el popup de información */
        .about-popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 10000;
          backdrop-filter: blur(5px);
        }

        .about-popup-container {
          background: white;
          border-radius: 20px;
          padding: 40px;
          max-width: 500px;
          width: 90%;
          text-align: center;
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
          animation: popupSlideIn 0.3s ease-out;
        }

        @keyframes popupSlideIn {
          from {
            opacity: 0;
            transform: translateY(-30px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .about-popup-logo {
          width: 120px;
          height: 120px;
          margin: 0 auto 20px;
          border-radius: 15px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        }

        .about-popup-title {
          font-size: 28px;
          font-weight: bold;
          color: #1e40af;
          margin-bottom: 10px;
        }

        .about-popup-version {
          font-size: 18px;
          color: #64748b;
          margin-bottom: 20px;
        }

        .about-popup-developer {
          font-size: 16px;
          color: #374151;
          margin-bottom: 15px;
          font-weight: 500;
        }

        .about-popup-trademark {
          font-size: 14px;
          color: #64748b;
          margin-bottom: 30px;
          font-style: italic;
        }

        .about-popup-links {
          display: flex;
          flex-direction: column;
          gap: 15px;
          margin-bottom: 30px;
        }

        .about-popup-link {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 12px 20px;
          background: #f8fafc;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          text-decoration: none;
          color: #374151;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .about-popup-link:hover {
          background: #1e40af;
          color: white;
          border-color: #1e40af;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(30, 64, 175, 0.3);
        }

        .about-popup-close {
          position: absolute;
          top: 15px;
          right: 15px;
          background: #f1f5f9;
          border: none;
          border-radius: 50%;
          width: 35px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .about-popup-close:hover {
          background: #e2e8f0;
          transform: scale(1.1);
        }

        .about-popup-email {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
        }

        .about-popup-email:hover {
          background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
        }

        .about-popup-whatsapp {
          background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
          color: white;
          border: none;
        }

        .about-popup-whatsapp:hover {
          background: linear-gradient(135deg, #20b358 0%, #0d6b5f 100%);
        }

        .about-popup-website {
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
          color: white;
          border: none;
        }

        .about-popup-website:hover {
          background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
        }
      `}</style>

      {/* Popup de información */}
      {aboutPopupOpen && (
        <div className="about-popup-overlay" onClick={closeAboutPopup}>
          <div className="about-popup-container" onClick={(e) => e.stopPropagation()}>
            <button className="about-popup-close" onClick={closeAboutPopup}>
              <X size={20} />
            </button>
            
            <img 
              src="/sf3/ventas/logosinfilas.png" 
              alt="SinFilas Logo" 
              className="about-popup-logo"
            />
            
            <h2 className="about-popup-title">Versión 3.0</h2>
            <p className="about-popup-developer">Desarrollado por Aldo Frías</p>
            <p className="about-popup-trademark">SinFilas® es marca registrada</p>
            
            <div className="about-popup-links">
              <a 
                href="https://www.sivol.com.ar" 
                target="_blank" 
                rel="noopener noreferrer"
                className="about-popup-link about-popup-website"
              >
                🌐 Sitio Web
              </a>
              
              <a 
                href="https://wa.me/5492235272479" 
                target="_blank" 
                rel="noopener noreferrer"
                className="about-popup-link about-popup-whatsapp"
              >
                📱 WhatsApp
              </a>
              
              <a 
                href="mailto:soporte@sinfilas.com.ar"
                className="about-popup-link about-popup-email"
              >
                ✉️ Soporte Técnico
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout;